import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
} from "@elaniintc/goes-design-system";

interface EllipsisDropdownProps {
  entity: string;
  id: string;
  onRename: (id: string) => void;
  onMoveUp: (id: string) => void;
  onMoveDown: (id: string) => void;
  onDelete: (id: string) => void;
  canMoveUp: boolean;
  canMoveDown: boolean;
  canDelete: boolean;
  canEdit: boolean;
}

export default function SectionOptions({
  entity,
  id,
  onRename,
  onMoveUp,
  onMoveDown,
  onDelete,
  canMoveUp,
  canDelete,
  canEdit,
  canMoveDown,
}: EllipsisDropdownProps) {
  if (!canEdit && !canDelete) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="xs" className="w-8 h-8 p-0">
          <Icon type="far" name="ellipsis-vertical" className="text-current" />
          <span className="sr-only">
            Acciones para {entity} {id}
          </span>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className="w-[200px] rounded-lg border border-neutral p-2 bg-neutral-object text-body font-normal"
        side="bottom"
        align="start"
        sideOffset={4}
      >
        <DropdownMenuGroup>
          {/* Cambiar nombre */}
          {canEdit && (
            <DropdownMenuItem
              className="flex items-center px-3 py-2 hover:bg-neutral-object-accent-silent cursor-pointer"
              onClick={() => onRename(id)}
            >
              <span className="text-body"> Cambiar nombre</span>
              <Icon type="far" name="edit" className="mr-2 ml-auto" />
            </DropdownMenuItem>
          )}

          {/* Mover arriba */}
          {canEdit && (
            <DropdownMenuItem
              className={`flex items-center px-3 py-2 cursor-pointer ${
                canMoveUp
                  ? "hover:bg-neutral-object-accent-silent"
                  : "opacity-40 cursor-not-allowed"
              }`}
              onClick={() => canMoveUp && onMoveUp(id)}
              disabled={!canMoveUp}
            >
              <span className="text-body">Mover arriba</span>
              <Icon type="far" name="arrow-up" className="mr-2 ml-auto" />
            </DropdownMenuItem>
          )}

          {/* Mover abajo */}
          {canEdit && (
            <DropdownMenuItem
              className={`flex items-center px-3 py-2 cursor-pointer ${
                canMoveDown
                  ? "hover:bg-neutral-object-accent-silent"
                  : "opacity-40 cursor-not-allowed"
              }`}
              onClick={() => canMoveDown && onMoveDown(id)}
              disabled={!canMoveDown}
            >
              Mover abajo
              <Icon type="far" name="arrow-down" className="mr-2 ml-auto" />
            </DropdownMenuItem>
          )}

          {/* Eliminar */}
          {canDelete && (
            <DropdownMenuItem
              className="flex items-center px-3 py-2 hover:bg-neutral-object-accent-silent cursor-pointer text-destructive"
              onClick={() => onDelete(id)}
            >
              <span className="text-danger"> Eliminar</span>
              <Icon
                type="far"
                name="trash"
                className="ml-auto mr-2 text-danger"
              />
            </DropdownMenuItem>
          )}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
